export default "/images/vendor/@coreui/icons/svg/flag/cif-cm.svg?d8ee791ca4f2a53499cb95543e7977e0";